import React, { Component } from "react";
import { Icon, Button, Modal, Table, Form, Input, message, Tooltip, Select, Upload } from "antd";
import {
	getCustomSignatureList,
	getNotConfigHospitalList,
	addCustomSignature,
	editCustomSignature,
	delCustomSignature
} from "@/request/api";
import { requestErrorLog } from "@/common/util";
import "./customSignature.scss";
import axios from "axios";
const { confirm } = Modal;
const { Option } = Select;

class CustomSignature extends Component {
	constructor(props) {
		super(props);
		this.state = {
			rowData: "",
			tableList: [],
			hospitalData: [],
			userHosDept: [],
			Columns: [
				{
					title: "医院名称",
					dataIndex: "HOSPITAL_NAME",
					key: "HOSPITAL_NAME",
					width: 350,
					ellipsis: true,
					render: (text) => {
						return (
							<Tooltip placement="topLeft" title={text}>
								<span>{text}</span>
							</Tooltip>
						);
					}
				},
				{
					title: "审核人",
					dataIndex: "CHECK_SIG_NAME",
					key: "CHECK_SIG_NAME",
					align: "center",
					width: 300,
					render: (text) => {
						return text ? text : <span style={{ color: "#F40" }}>无</span>;
					}
				},
				{
					title: "报告人",
					dataIndex: "REPORT_SIG_NAME",
					key: "REPORT_SIG_NAME",
					align: "center",
					width: 300,
					render: (text) => {
						return text ? text : <span style={{ color: "#F40" }}>无</span>;
					}
				},
				{}
			],
			PageNo: 1,
			PageSize: 10,
			RowCount: 0,
			checkSignatureUrl: "",
			checkSignatureFileName: "",
			reportSignatureFileName: "",
			reportSignatureUrl: "",
			checkSignatureFile: null,
			reportSignatureFile: null
		};
	}

	componentDidMount() {
		this.getList();
	}

	getHospitalList = () => {
		// 获取医院列表
		getNotConfigHospitalList().then((res) => {
			if (res && res.Status === 1) {
				const data = res.Result;
				this.setState({
					hospitalData: data
				});
			} else {
				requestErrorLog("", "权限管理-自定义签名-获取医院列表报错", 0, true);
			}
		});
	};

	getList = () => {
		let params = {
			searchValue: this.props.form.getFieldValue("searchInfo") || "",
			pageNo: this.state.PageNo,
			pageSize: this.state.PageSize
		};
		getCustomSignatureList(params).then((res) => {
			if (res && res.Status === 1) {
				const dataList = res.Result.dataList;
				let RowCount = res.Result.rowCount;
				this.setState({
					tableList: dataList,
					RowCount
				});
			} else {
				requestErrorLog("", "权限管理-自定义签名-获取有签名的医院列表报错", 0, true);
			}
		});
	};

	handleAdd = () => {
		// 新增
		this.setState({
			isModalVisible: true,
			modalTitle: "ADD",
			rowData: "",
			checkSignatureUrl: "",
			reportSignatureUrl: "",
			checkSignatureFile: null,
			reportSignatureFile: null,
			reportSignatureFileName: "",
			checkSignatureFileName: ""
		});
		this.getHospitalList();
	};

	handleEdit = () => {
		if (this.state.rowData) {
			this.setState({
				isModalVisible: true,
				modalTitle: "EDIT",
				checkSignatureUrl: window.g.baseURL + "/" + this.state.rowData.REALTIVE_CHECK_SIG,
				reportSignatureUrl: window.g.baseURL + "/" + this.state.rowData.REALTIVE_REPORT_SIG,
				reportSignatureFileName: this.state.rowData.REPORT_SIG_NAME,
				checkSignatureFileName: this.state.rowData.CHECK_SIG_NAME
			});
			this.getHospitalList();
		} else {
			message.warning("请先选择要操作的数据");
		}
	};

	handleDelete = () => {
		// 删除
		const { rowData } = this.state;
		if (!rowData) {
			message.warning("请先选择要操作的数据");
		} else {
			confirm({
				title: "删除操作",
				content: "确认删除该医院签名信息吗？",
				onOk: () => {
					delCustomSignature(rowData.ID).then((res) => {
						if (res && res.Status === 1) {
							message.success("删除成功");
							this.clearSignature();
						} else {
							requestErrorLog("", "权限管理-上传自定义签名删除接口报错：" + res, 0, false);
						}
					});
				}
			});
		}
	};

	handleSubmit = async () => {
		const { hospitalData, rowData, modalTitle } = this.state;
		let hospital_Code = this.props.form.getFieldValue("HOSPITAL_UID");
		if (modalTitle === "EDIT") {
			hospital_Code = rowData.HOSPITAL_CODE;
		}
		if (!hospital_Code) return message.error("请选择医院");
		try {
			await this.uploadReportSignatureFn(hospital_Code);
			await this.uploadCheckSignatureFn(hospital_Code);
			let hospitalInfo = hospitalData.find((item) => item.hospital === hospital_Code);
			let params = {
				HOSPITAL_CODE: modalTitle === "EDIT" ? rowData.HOSPITAL_CODE : hospital_Code,
				HOSPITAL_NAME: modalTitle === "EDIT" ? rowData.HOSPITAL_NAME : hospitalInfo.hospital_code,
				REPORT_SIG_NAME: this.state.reportSignatureFileName,
				CHECK_SIG_NAME: this.state.checkSignatureFileName
			};
			if (modalTitle === "EDIT") {
				params.ID = rowData.ID;
				editCustomSignature(params).then((res) => {
					if (res.Status === 1) {
						message.success("编辑成功");
						this.clearSignature();
					} else {
						requestErrorLog("", "权限管理-上传自定义签名编辑：" + res, 0, false);
					}
				});
				return;
			}
			addCustomSignature(params).then((res) => {
				if (res.Status === 1) {
					message.success("添加成功");
					this.clearSignature();
				} else {
					requestErrorLog("", "权限管理-上传自定义签名添加接口报错：" + res, 0, false);
					return message.error("添加失败，有相同医院编码存在请编辑");
				}
			});
		} catch (error) {
			message.error("上传失败请稍后重试");
			requestErrorLog("", "权限管理-上传自定义签名文件报错：" + error, 0, false);
		}
	};

	onClickRow = (record) => {
		return {
			onClick: () => {
				this.setState({
					rowData: record
				});
			}
		};
	};

	setRowClassName = (record) => {
		return record === this.state.rowData ? "clickRowStyl" : "";
	};

	handleCancel = () => {
		this.setState({
			isModalVisible: false
		});
	};

	//页码改变
	changePageFn = (PageNo) => {
		this.setState(
			{
				PageNo
			},
			() => {
				this.getList();
			}
		);
	};
	handleSearch = () => {
		this.setState(
			{
				PageNo: 1,
				PageSize: 10
			},
			() => {
				this.getList();
			}
		);
	};
	beforeUpload = (type, file) => {
		const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
		if (!isJpgOrPng) {
			message.error("请选择JPG或者PNG格式图片");
			return false;
		}
		const isLt2M = file.size / 1024 / 1024 < 2;
		if (!isLt2M) {
			message.error("图片不能大于2M");
			return false;
		}
		let url = window.URL ? window.URL.createObjectURL(file) : window.webkitURL.createObjectURL(file);
		this.setState({
			[type + "Url"]: url,
			[type + "File"]: file
		});
		return false;
	};

	uploadReportSignatureFn = (HospitalCode) => {
		return new Promise((resolve, reject) => {
			if (!this.state.reportSignatureFile) {
				return resolve(false);
			}
			let formData = new FormData();
			formData.append("", this.state.reportSignatureFile);
			formData.append("HospitalCode", HospitalCode);
			formData.append("PicType", "report");
			let config = { headers: { "Content-Type": "multipart/form-data" } };
			let url = window.g.baseURL + "/api/CastomSignaturePicture/UploadCastomSignaturePicture";
			axios
				.post(url, formData, config)
				.then((res) => {
					if (res.data.Status === 1) {
						this.setState(
							{
								reportSignatureUrl: window.g.baseURL + "/" + res.data.Result?.FileUrl,
								reportSignatureFileName: res.data.Result?.FileName
							},
							() => {
								resolve(true);
							}
						);
					}
				})
				.catch((err) => {
					requestErrorLog("", "权限管理-上传自定义签名报告人签名报错：" + err, 0, false);
				});
		});
	};
	uploadCheckSignatureFn = (HospitalCode) => {
		return new Promise((resolve, reject) => {
			if (!this.state.checkSignatureFile) {
				return resolve(false);
			}
			let formData = new FormData();
			formData.append("", this.state.checkSignatureFile);
			formData.append("HospitalCode", HospitalCode);
			formData.append("PicType", "check");
			let config = { headers: { "Content-Type": "multipart/form-data" } };
			let url = window.g.baseURL + "/api/CastomSignaturePicture/UploadCastomSignaturePicture";
			axios
				.post(url, formData, config)
				.then((res) => {
					if (res.data.Status === 1) {
						this.setState(
							{
								checkSignatureUrl: window.g.baseURL + "/" + res.data.Result?.FileUrl,
								checkSignatureFileName: res.data.Result?.FileName
							},
							() => {
								resolve(true);
							}
						);
					}
				})
				.catch((err) => {
					requestErrorLog("", "权限管理-上传自定义签名审核人签名报错：" + err, 0, false);
				});
		});
	};
	delSignature = (type) => {
		this.setState({
			[type + "Url"]: "",
			[type + "File"]: null,
			[type + "FileName"]: ""
		});
	};
	clearSignature = () => {
		this.setState({
			checkSignatureUrl: "",
			reportSignatureUrl: "",
			checkSignatureFile: null,
			reportSignatureFile: null,
			reportSignatureFileName: "",
			checkSignatureFileName: "",
			isModalVisible: false,
			rowData: ""
		});
		this.getList();
	};
	// 切换医院时
	changeHospital = (value, option) => {};

	render() {
		const { getFieldDecorator } = this.props.form;
		const { isModalVisible, modalTitle, Columns, tableList, rowData, hospitalData } = this.state;
		const formItemLayout = {
			labelCol: { span: 4 },
			wrapperCol: { span: 14 }
		};
		return (
			<>
				<div className="btnStyle" style={{ marginBottom: "10px" }}>
					<Button onClick={this.handleAdd}>
						<Icon type="plus-circle" />
						添加
					</Button>
					<Button onClick={this.handleEdit}>
						<Icon type="minus-circle" />
						修改
					</Button>
					<Button onClick={this.handleDelete}>
						<Icon type="close-circle" />
						删除
					</Button>
				</div>

				<Form layout="inline">
					<Form.Item label="信息查询">{getFieldDecorator("searchInfo")(<Input allowClear={true} />)}</Form.Item>
					<Button onClick={this.handleSearch}>查询</Button>
				</Form>

				<Table
					columns={Columns}
					dataSource={tableList}
					rowKey={(record) => record.ID}
					pagination={{
						total: this.state.RowCount,
						current: this.state.PageNo,
						onChange: this.changePageFn
					}}
					onRow={this.onClickRow}
					rowClassName={this.setRowClassName}
				/>
				{isModalVisible ? (
					<Modal
						title={
							<div className="patient_title">
								<img alt="" src={require("@/assets/image/ecg.png").default} className="addIcon" />
								<span>{modalTitle === "ADD" ? "添加签名" : "编辑签名"}</span>
							</div>
						}
						visible={isModalVisible}
						maskClosable={false}
						onOk={this.handleSubmit}
						onCancel={this.handleCancel}>
						<Form labelAlign="right" {...formItemLayout} className="customSignatureModal">
							<Form.Item label="所属医院" className="settingHospitalRequire">
								{getFieldDecorator("HOSPITAL_UID", {
									initialValue: modalTitle === "EDIT" ? rowData.HOSPITAL_NAME : undefined,
									rules: [{ required: true, message: "请选择医院" }]
								})(
									<Select
										style={{ width: "250px" }}
										onChange={this.changeHospital}
										showSearch
										placeholder="请选择医院"
										disabled={modalTitle === "EDIT" ? true : false}
										optionFilterProp="children">
										{hospitalData.map((item) => (
											<Option key={item.hospital} value={item.hospital}>
												{item.hospital_code}
											</Option>
										))}
									</Select>
								)}
							</Form.Item>
							<Form.Item label="报告人">
								<div className="signatureBox">
									<div>
										<Upload beforeUpload={this.beforeUpload.bind(this, "reportSignature")} showUploadList={false}>
											<Button style={{ color: "#fff" }}>上 传</Button>
										</Upload>
										<br />
										<Button type="danger" className="delBtn" onClick={this.delSignature.bind(this, "reportSignature")}>
											删 除
										</Button>
									</div>
									<div className="signature">
										{this.state.reportSignatureUrl ? <img alt="" src={this.state.reportSignatureUrl} /> : null}
									</div>
								</div>
							</Form.Item>
							<Form.Item label="审核人">
								<div className="signatureBox">
									<div>
										<Upload beforeUpload={this.beforeUpload.bind(this, "checkSignature")} showUploadList={false}>
											<Button style={{ color: "#fff" }}>上 传</Button>
										</Upload>
										<br />
										<Button type="danger" className="delBtn" onClick={this.delSignature.bind(this, "checkSignature")}>
											删 除
										</Button>
									</div>
									<div className="signature">
										{this.state.checkSignatureUrl ? <img alt="" src={this.state.checkSignatureUrl} /> : null}
									</div>
								</div>
							</Form.Item>
						</Form>
					</Modal>
				) : null}
			</>
		);
	}
}
export default Form.create({})(CustomSignature);
